import { useEffect } from "react";

export function useAsyncEffect(asyncHandler: () => Promise<any>) {
  useEffect(() => {
    (async () => {
      await asyncHandler();
    })();
  }, [asyncHandler]);
}
